<script>

  import { External, M } from '../../external';
  import { onDestroy, onMount } from 'svelte';
  import { makeWebsiteRequest } from '../../Common/tools';

  export let amount, futureAmount, currency, settings;

  let elements, cardInstance, cardField, error;

  export const onAmountChange = () => {
  };

  export const getPaymentDetails = async (billingInfo) => {
    return new Promise(async (resolve, reject) => {
      External.CPanel.disableUI(true);

      let details = {
        name: billingInfo.name || '',
        email: External.userEmail
      };

      if (billingInfo.countryCode) {
        details.address = {};
        if (billingInfo.countryCode === 'UK')
          details.address.country = 'UK';
        else if (billingInfo.countryCode === 'EL')
          details.address.country = 'GR';
        else
          details.address.country = billingInfo.countryCode;
        if (billingInfo.zip)
          details.address.postal_code = billingInfo.zip;
        if (billingInfo.state)
          details.address.state = billingInfo.state;
        if (billingInfo.city)
          details.address.city = billingInfo.city;
        if (billingInfo.address)
          details.address.line1 = billingInfo.address;
      }

      let amountToAuthorize = amount;
      if (amountToAuthorize < 1) {
        amountToAuthorize = 0;
      }

      let result = await makeWebsiteRequest({
        action: 'getStripeClientToken',
        data: {
          amount: amountToAuthorize
        }
      });

      if (!result.ok) {
        External.CPanel.enableUI();
        reject();
      }

      let onCardAuthorizationEnd = (result) => {
        External.CPanel.enableUI();
        if (result.error) {
          let error = result.error.message || result.error;
          External.Tools.showError(error);
          reject(error);
        } else {
          resolve({
            nonce: amountToAuthorize > 0.1 ? result.paymentIntent.id : result.setupIntent.id
            //cardType: result.token.card.brand,
            //lastTwo: result.token.card.last4.substr(2)
          });
        }
      };

      if (amountToAuthorize > 0.1) {
        window.PlatformStripeInstance.confirmCardPayment(result.data, {
          payment_method: {
            card: cardInstance,
            billing_details: details
          }
        }).then(onCardAuthorizationEnd);
      } else {
        window.PlatformStripeInstance.handleCardSetup(result.data, cardInstance, {
            payment_method_data: {
              billing_details: details
            }
          }
        ).then(onCardAuthorizationEnd);
      }
    });
  };

  let setup = async () => {

    if (!window.PlatformStripeInstance) {
      window.PlatformStripeInstance = window.Stripe(settings.publishableKey);
    }
    elements = PlatformStripeInstance.elements();
    cardInstance = elements.create('card', {
      hidePostalCode: true
    });

    cardInstance.mount(cardField);
    cardInstance.addEventListener('change', function(event) {
      if (event.error) {
        error = event.error.message;
      } else {
        error = null;
      }
    });
  };

  let teardown = () => {
    if (cardInstance !== null) {
      try {
        cardInstance.destroy();
        cardInstance = null;
        elements = null;
      } catch (error) {
      }
    }
  };

  onMount(() => {
    External.WebPlatform.requestScripts([{
      script: 'https://js.stripe.com/v3/',
      check: () => !External.isUndefined(window.Stripe)
    }], setup);
  });

  onDestroy(teardown);
</script>

<div class="payment-info">
  <div class="col20 f-left card-form">
    <h4>{M.CRED_CARD_INFO}</h4>
    <div data-name="card-number" class="input-field mt-15" bind:this={cardField}></div>
    <div id="stripeFields" class="col20 f-left">
      {#if error}
        <span class="error-message"></span>
      {/if}
    </div>
  </div>
</div>
